module.exports = __webpack_public_path__ + "static/img/icon_professional_service.16202fa1.svg";